<template>
  <div>

    <ed-alert
      class="mb-3"
      type="warning"
      title="Exames Vinculados no PCMSO"
    />

    <ed-table
      :tableData="tableData"
      :tableHead="tableHead"
      :pagination="pagination"
      :response="response"
      :loadingTable="loadingTable"
      disableCheckAll
      disabledConfigCell
      disableInputSearch
    />
  </div>
</template>

<script>

import Rest from 'common/rest'
import EdAlert from 'common/alert'
import EdTable from 'common/table'

export default {
    name: 'EmpresaCadastro',
    components:{EdTable,EdAlert},
    mixins:[Rest],
    props:{
    id_ghe:{
      type: Number,
      default:null
    },
  },
  watch:{
    id_ghe(){
      this.getPCMSO()
    },
  },

  data () {
    return{
      formData:{
        pcmso:null,
      },
      pagination:{},
      response:{},
      tableData:[],
      tableHead:[
        {
          key: 'exame',
          sortable: true,
          label: 'Exame',
        },
        {
          key: 'adm',
          sortable: true,
          show_html:true,
          label: 'Admissional',
        },
        {
          key: 'apos_adm',
          sortable: true,
          show_html:true,
          label: 'Após Admissional',
        },
        {
          key: 'dem',
          sortable: true,
          show_html:true,
          label: 'Demissional',
        },
        {
          key: 'ret_tra',
          sortable: true,
          show_html:true,
          label: 'Retorno ao Trabalho',
        },
        {
          key: 'mud_fun',
          sortable: true,
          show_html:true,
          label: 'Mudança de Função',
        },
        {
          key: 'periodicidade',
          sortable: true,
          show_html:true,
          label: 'Periódico',
        },
      ],
      showModal:false,
      loadingTable:false,
    }
  },
  created(){
  },
  mounted(){
    this.getPCMSO()
  },

  methods: {

    getPCMSO(){

      if(!this.id_ghe)return;

      this.loadingTable = true;
      this.formData.pcmso = null;
      this.response = {};

      this.get('pcmso/ghe/exame/'+this.id_ghe).then((result) =>{
        result = result[0];

        this.response = result;
        this.loadingTable = false;

        var data = [], tableData = [], pagination = {};

        if(result.status == 200){

          data = result.data.data;

          for (var i = 0; i < data.length; i++) {
            
            var periodicidade = (data[i].periodicidade != '0' ? '<span style="color:green">'+data[i].periodicidade+' meses</span>' : '<span style="color:red">Não</span>');

            if(data[i].per_id1 != '0'){
              periodicidade += "<span style='color:#000'>\nA partir dos "+data[i].per_id1+" anos</span>"
            }

            if(data[i].per_id2 != '0'){
              periodicidade += "<span style='color:#000'>\nAté os  "+data[i].per_id2+" anos</span>"
            }

            var item = {
              id: data[i].id,
              exame: data[i].exame.nome,
              adm: (data[i].adm != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>'),
              apos_adm: (data[i].apos_adm != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>'),
              dem: (data[i].dem != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>'),
              ret_tra: (data[i].ret_tra != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>'),
              mud_fun: (data[i].mud_fun != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>'),
              periodicidade: periodicidade,
              _data: data[i],
              buttons : []
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        this.tableData = tableData;
        this.pagination = pagination;

      });
    },
  }
}
</script>



// WEBPACK FOOTER //
// pcmso.vue?2865e5cd